import React from 'react';
import { Button, Card, Stack, Text } from '@mantine/core';
import { IconPlugConnectedX, IconRefresh } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { POP } from '@/theme/motion';

type Props = {
    title?: string;
    body?: string;
    onRetry?: () => void;
    retrying?: boolean;
};

const ErrorState: React.FC<Props> = ({
    title = 'Non è stato possibile caricare i dati',
    body = 'Il server non ha risposto. Può essere la connessione, o il servizio che sta ripartendo.',
    onRetry,
    retrying = false,
}) => (
    <Card padding="xl" radius="lg" withBorder>
        <Stack align="center" gap="sm" style={{ textAlign: 'center' }}>
            <motion.div variants={POP} initial="hidden" animate="visible" style={{ color: 'var(--bd-status-danger)' }}>
                <IconPlugConnectedX size={30} stroke={1.6} />
            </motion.div>
            <Text fw={700} style={{ color: 'var(--bd-text-strong)' }}>{title}</Text>
            <Text size="sm" c="dimmed" maw={440}>{body}</Text>
            {onRetry ? (
                <Button variant="light" leftSection={<IconRefresh size={16} />} onClick={onRetry} loading={retrying} mt="xs">
                    Riprova
                </Button>
            ) : null}
        </Stack>
    </Card>
);

export default ErrorState;
